// Thin manifest-style progress bar (`.mp-bar` with inner fill `<i>`), extracted
// from the manifest builder's role/overall progress rows. The fill width is set
// via an inline percent exactly as the original markup did; the variant selects
// the fill colour token (success vs primary).
export type ProgressBarVariant = "success" | "primary";

export interface ProgressBarProps {
  /** Fill amount, 0–100. Rendered verbatim as an inline `width: ${value}%`. */
  value: number;
  /** Fill colour: success = `--success`, primary = `--primary` (default). */
  variant?: ProgressBarVariant;
}

export function ProgressBar({ value, variant = "primary" }: ProgressBarProps) {
  return (
    <span className="mp-bar">
      <i
        style={{
          width: `${value}%`,
          background: variant === "success" ? "var(--success)" : "var(--primary)",
        }}
      />
    </span>
  );
}
